import { render, staticRenderFns } from "./RepositoryInfo.vue?vue&type=template&id=cde0ad96&scoped=true&"
import script from "./RepositoryInfo.vue?vue&type=script&lang=js&"
export * from "./RepositoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./RepositoryInfo.vue?vue&type=style&index=0&id=cde0ad96&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde0ad96",
  null
  
)

export default component.exports